/**
 * Wraps all AuditLog components in a default container. If you want to
 * give all AuditLog views a sidebar for example, you would set that here.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import AuditLogsTopNav from '../../admin/components/AuditLogsTopNav.js.jsx';

const AuditLogLayout = props => {
  return (
    <div className="-author-layout">
      <AuditLogsTopNav />
      <div className="-content yt-container">
        {props.children}
      </div>
    </div>
  )
}
  

export default AuditLogLayout;



// WEBPACK FOOTER //
// modules/auditLog/components/AuditLogLayout.js.jsx